module.exports = __webpack_public_path__ + "img/long-light-monochrome-outline.1cb99f1.svg";